import React, { useState, useRef, useEffect } from "react";

const BreadcrumbWithDropdown = ({
  breadcrumb,
  setCurrentFolder,
  setCurrentParentId,
  resetFolders,
  setIsCommonFolder,
  setBreadcrumb,
  folderlist,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const VISIBLE_ITEMS = 2; // Number of items to show at end of breadcrumb (excluding root)

  const hasOverflow = breadcrumb.length > VISIBLE_ITEMS;
  const visibleBreadcrumbs = hasOverflow
    ? breadcrumb.slice(breadcrumb.length - VISIBLE_ITEMS)
    : breadcrumb;
  const hiddenBreadcrumbs = hasOverflow
    ? breadcrumb.slice(0, breadcrumb.length - VISIBLE_ITEMS)
    : [];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleBreadcrumbClick = (
    folderId,
    index,
    isHiddenItem = false,
    folderType = ""
  ) => {
    setCurrentParentId(folderId);

    if (isHiddenItem) {
      const actualIndex = hiddenBreadcrumbs.findIndex(
        (item) => item.id === folderId
      );
      if (actualIndex !== -1) {
        const newBreadcrumb = breadcrumb.slice(0, actualIndex + 1);
        setBreadcrumb(newBreadcrumb);
      }
      setShowDropdown(false);
    } else {
      const actualIndex = hiddenBreadcrumbs.length + index;
      const newBreadcrumb = breadcrumb.slice(0, actualIndex + 1);
      setBreadcrumb(newBreadcrumb);
    }

    folderType === "common_folder"
      ? setIsCommonFolder(true)
      : setIsCommonFolder(false);
  };

  return (
    <div className="flex items-center mb-6 text-black font-bold text-sm bg-white px-5">
      {/* Root item */}
      <span
        className={`cursor-pointer py-4 relative ${
          breadcrumb.length === 0
            ? "after:absolute after:left-0 after:bottom-0 after:w-[100%] after:h-[2px] after:bg-blue-500"
            : ""
        }`}
        onClick={() => {
          setCurrentParentId(null);
          resetFolders();
        }}
      >
        {folderlist?.result?.length === 0 ? "Folders" : "Bajaj"}{" "}
      </span>

      {hiddenBreadcrumbs.length > 0 && (
        <div className="relative mx-1">
          <span className="text-gray-800 py-4 mx-1">/</span>
          <button
            className="text-blue-500 py-1 px-2 rounded hover:bg-blue-50"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            ...
          </button>

          {showDropdown && (
            <div
              ref={dropdownRef}
              className="absolute top-full left-0 mt-1 bg-white shadow-lg rounded-md py-2 z-10 min-w-40 border border-gray-200"
            >
              {hiddenBreadcrumbs.map((folder, index) => (
                <div
                  key={folder.id}
                  className="px-4 py-2 hover:bg-blue-50 cursor-pointer text-blue-500"
                  onClick={() => {
                    setCurrentFolder(folder); // ✅ Set the current folder object
                    handleBreadcrumbClick(folder.id, index, true, folder.folderType);
                  }}
                >
                  {folder.name}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Visible breadcrumbs */}
      {visibleBreadcrumbs.map((folder, index) => (
        <React.Fragment key={folder.id}>
          <span className="text-gray-800 mx-1 py-4">/</span>
          <span
            className={`cursor-pointer relative py-4 text-blue-500 ${
              index === visibleBreadcrumbs.length - 1
                ? "after:absolute after:left-0 after:bottom-0 after:w-[100%] after:h-[2px] after:bg-blue-500"
                : ""
              }`}
            onClick={() => {
              setCurrentFolder(folder); // ✅ Set current folder object
              handleBreadcrumbClick(folder.id, index)// ✅ Call breadcrumb handler
            }}
          >
            {folder.name}
          </span>

        </React.Fragment>
      ))}
    </div>
  );
};

export default BreadcrumbWithDropdown;
